import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const channelRouter: Array<RouteRecordRaw> = [
    {
        path: '/supplier',
        component: Layout,
        name: '供应商后台管理',
        redirect: '/supplier/reconciliation-list',
        meta: { title: '供应商管理', icon: 'icon-channel', alwaysShow: true },
        children: [
            {
                path: 'reconciliation-list',
                name: '供应商对账管理',
                component: () => import('@/views/invoice/ReconciliationList.vue'),
                meta: { title: '供应商对账' }
            },
            {
                path: 'reconciliation-detail',
                name: '供应商对账详情查看',
                component: () => import('@/views/invoice/ReconciliationEdit.vue'),
                meta: { title: '供应商对账详情' }
            },
            {
                path: 'invoice-list',
                name: '供应商发票列表',
                component: () => import('@/views/merchant/InvoiceList.vue'),
                meta: {
                    title: '发票列表',
                    v: 3,   // 供应商端
                    keepAlive: true,
                    depth: 30
                }
            },
            {
                path: 'invoice-edit',
                name: '供应商发票编辑',
                component: () => import('@/views/merchant/InvoiceEdit.vue'),
                meta: { title: '发票编辑', depth: 40 }
            },
            {
                path: 'supplier-list',
                name: '供应商预付款列表',
                component: () => import('@/views/couponline/AdvanceChargeList.vue'),
                meta: { title: '预付款列表' }
            },
            {
                path: 'supplier-edit',
                name: '供应商预付款编辑',
                component: () => import('@/views/couponline/AdvanceChargeInfo.vue'),
                meta: { title: '预付款编辑' }
            },
            {
                path: 'supplier-log',
                name: '供应商预付款消费日志',
                component: () => import('@/views/couponline/AdvanceChargeLog.vue'),
                meta: { title: '预付款消费日志' }
            },
        ]
    }
]

export default channelRouter